import { createApp } from 'vue'
import { createAuth0 } from "@auth0/auth0-vue"
import Shell from './Shell.vue'
import router from './Router/router'

//import { VueReCaptcha } from 'vue-recaptcha-v3'

//The http client we are using to make API calls, axios
import axios from './Services/HttpClient/axios-plugin'
import { AxiosKey } from './Services/HttpClient/symbols'

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
//import { VDataTable } from 'vuetify/labs/VDataTable';
import { aliases, mdi } from 'vuetify/iconsets/mdi';
import "@mdi/font/css/materialdesignicons.css";
import { customDarkTheme, customLightTheme } from './Themes/siteThemes';

//The supported state manager for this project
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';

//Adds global functions
import CommonFunctions from '@/Services/Helper/common-functions';
//import { IReCaptchaOptions } from 'vue-recaptcha-v3/dist/IReCaptchaOptions'



const CommonFunctionOptions = {
    dateFormat: "MM/dd/yyyy",
    timestampFormat: "MM/dd/yyyy h:mm tt Z",
};

const vuetify = createVuetify({
    components,
    directives,
    theme: {
        defaultTheme: "customLightTheme",
        themes: {
            customLightTheme,
            customDarkTheme
        }
    }
})

const app = createApp(Shell);
const piniaStateManager = createPinia();
piniaStateManager.use(piniaPluginPersistedstate);

// Global error handler
app.config.errorHandler = (err, instance, info) => {

    // Handle the error globally
    console.error("Global error:", err as Error);
    console.log("Vue instance:", instance);
    console.log("Error info:", info);

    // Add code for UI notifications, reporting or other error handling logic
};

app.provide(AxiosKey, axios);
//const captchaOptions: IReCaptchaOptions = {
//    siteKey: '6Le9bVUpAAAAALpgBoNSJn678liLnaSUQ3ynbm6T', loaderOptions: {} }

app.use(router)
    .use(vuetify)
    .use(CommonFunctions, CommonFunctionOptions)
    /*.use(VueReCaptcha, captchaOptions)*/

app.mount('#app');